export default "__VITE_ASSET__C8C_JKCk__"